import { useLocal } from '@/i18n/LocalContext'
import { checkToken, getBindedPlayer } from '@/request/userServer'
import getReport, { createReport } from '@/report/create'
import { logout } from '@/request/utils'
import { useStore } from '@/store'
import { closeLoading, loading, toast } from '@/utils'
import { useEffect, useRef } from 'react'
import { keyDataConsumeTimeReport } from '@/monitor'
import appExpose from '@app/expose'

export default function usePlayer() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const logined = state.login.logined
  const isBinded = state.login.userInfo.isBinded
  const isCodeBinded = state.login.userInfo.isCodeBinded
  const checked = state.login.userInfo.checked
  const pending = useRef(false)

  useEffect(() => {
    const _cancel = () => {}

    if (pending.current) return

    pending.current = true

    const _reportLaunch = () => {
      const $report = getReport()
      if ($report) {
        $report('h5EventLaunch', {
          round: String(window.inSDK ? 1 : 2),
        })
      }
    }

    console.log('logined =>', logined)
    if (!logined) {
      createReport().then(() => {
        _reportLaunch()
      })
      appExpose.emitter.emit('getPreBaseData')
      setTimeout(() => {
        pending.current = false
      }, 4)
      return _cancel
    }

    loading()
    window.checkToken$
      .then(() => window.getBindedPlayer$)
      .then((res) => {
        const data: Record<string, unknown> = {
          checked: 1,
          isBinded: res.isUserBind,
          isCodeBinded: res.isCodeBind,
          playerType: res.category,
        }

        if (res.isUserBind) {
          console.log('角色已绑定')
          toast($t('登录成功'))
          data.playerId = res.playerId
          data.zoneId = res.zoneId
          data.serverId = res.serverId
          data.playerName = res.nickName
        } else {
          appExpose.emitter.emit('getPreBaseData')
          data.playerId = ''
          data.zoneId = res.zoneId
          data.serverId = ''
          data.playerName = ''
        }
        createReport(
          data.playerName,
          data.playerId,
          data.serverId,
          data.zoneId
        ).then(() => {
          _reportLaunch()
        })

        dispatch({
          type: 'bindPlayer',
          data,
        })
      })
      .catch(() => {
        createReport().then(() => {
          _reportLaunch()
        })
        dispatch({
          type: 'bindPlayer',
          data: {
            checked: 2,
          },
        })
        logout($t('请更换账号登录'), true)
      })
      .finally(() => {
        pending.current = false
        closeLoading()

        _reportLaunch()
      })

    return _cancel
  }, [logined])

  return { logined, isBinded, checked, isCodeBinded }
}
